import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";

import { SearchFilterModule } from "../search-filter/search-filter.module";

import { SelectionListComponent } from "./selection-list.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatCardModule,
    MatListModule,
    MatChipsModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    SearchFilterModule,
  ],
  declarations: [SelectionListComponent],
  exports: [SelectionListComponent],
  providers: [],
})
export class SelectionListModule {}
